<template>


    <section class="space-xs text-center bg-gradient text-light">
      <div class="container">
          <div class="row">
            <div class="col">
                <span class="mr-2">Beta Version</span>
            </div>
            <!--end of col-->
          </div>
          <!--end of row-->
      </div>
      <!--end of container-->
    </section>
    <!--end of section-->

    <!-- <div class="navbar-container">
      <div class="bg-dark navbar-dark" data-sticky="top">
        <div class="container">
          <nav class="navbar navbar-expand-lg">
            <router-link class="navbar-brand" to="/">
                <img :alt="appname" src="assets/ardent-white.png" width="170" />
            </router-link>
          </nav>
        </div>
      </div>
    </div> -->

    <div class="main-container">
      <section class="bg-dark space-lg" data-jarallax data-speed="0.2">
        <img alt="Image" src="assets/img/graphic-bg-clouds-2.png" class="bg-image" />
        <div class="container">
          <div class="row align-items-center justify-content-between">
            <div class="col-12 col-md-6 col-lg-5 section-intro">
              <h1 class="display-5">{{appname}}</h1>
              <span class="lead">A new Normal, Make it Digital !</span>
            </div>
            <!--end of col-->
            <div class="col-12 col-md-6 col-lg-5">
              <div class="card">
                <div class="card-body">
                  <div>
                    <div class="form-group">
                      <label>Username</label>
                      <input type="text" class="form-control form-control-lg" placeholder="ERM/Mobile Office Username" v-model="data.username" required @keyup.enter="signin">
                    </div>
                    <div class="form-group">
                      <label>Password</label>
                      <input type="password" class="form-control form-control-lg" placeholder="Enter Password" v-model="data.password" required @keyup.enter="signin">
                    </div>

                    <!-- <div class="form-group">
                      <label>Company</label>
                      <select class="form-control form-control-lg" v-model="data.company" @keyup.enter="signin">
                        <option :value="company.company_code" v-for="(company, index) in companies" :key="index">{{company.company_name}}</option>
                      </select>
                    </div> -->

                    <jl-button :class="'btn btn-lg btn-success btn-block'" ref="signbutton" :eventClick="signin">Sign In</jl-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end of row-->
        </div>
        <!--end of container-->
      </section>
      <!--end of section-->

      <section>
        <div class="container" data-aos="fade-up">

          <div class="row justify-content-center text-center section-intro">
            <div class="col-12 col-md-9 col-lg-8">
              <h2 class="display-4" data-aos="fade-up" data-aos-delay="100">How It Works</h2>
              <span class="lead" data-aos="fade-up" data-aos-delay="200">You are welcome to use {{appname}} to keep your files synced and accessible anywhere.</span>

            </div>
            <!--end of col-->
          </div>
          <!--end of row-->

          <div class="row justify-content-around">

            <div class="col-md-5 col-7 mb-4">
              <div class="tab-content">
                <div class="tab-pane fade show active" id="content-1" role="tabpanel">
                  <img alt="Image" class="img-fluid w-100" src="assets/img/graphic-desktop.svg" />
                </div>
                <div class="tab-pane fade" id="content-2" role="tabpanel">
                  <img alt="Image" class="img-fluid w-100" src="assets/img/graphic-envelope.svg" />
                </div>
                <div class="tab-pane fade" id="content-3" role="tabpanel">
                  <img alt="Image" class="img-fluid w-100" src="assets/img/graphic-fingerprint.svg" />
                </div>
              </div>
            </div>
            <!--end of col-->
            <div class="col-lg-5 col-md-8 mb-4">
              <ul class="nav nav-cards" role="tablist">
                <li>
                  <a class="card active" data-toggle="tab" href="#content-1" role="tab" aria-controls="content-1" aria-selected="true">
                    <div class="card-body">
                      <div class="media align-items-center">
                        <div class="step-circle mr-4">1</div>
                        <div class="media-body">
                          <h5>Sign In</h5>
                          <span>
                            It’s even easier to signin using your Internal System Account.
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="card" data-toggle="tab" href="#content-2" role="tab" aria-controls="content-2" aria-selected="false">
                    <div class="card-body">
                      <div class="media align-items-center">
                        <div class="step-circle mr-4">2</div>
                        <div class="media-body">
                          <h5>Your Files Everywhere</h5>
                          <span>Access your files from wherever you are.</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="card" data-toggle="tab" href="#content-3" role="tab" aria-controls="content-3" aria-selected="false">
                    <div class="card-body">
                      <div class="media align-items-center">
                        <div class="step-circle mr-4">3</div>
                        <div class="media-body">
                          <h5>Safe</h5>
                          <span>Add file access or permission to keep files confidential to other users.</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <!--end of col-->

          </div>
          <!--end of row-->
        </div>
        <!--end of container-->
      </section>
      <!--end of section-->

      <jlfooter />
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {},
            companies: []
        }
    },
    methods: {
        signin(e) {
            this.$axios.post('/login', this.$qs.stringify(this.data))
            .then(res => {
                if(res.status === 200) window.location.reload(true);
                else this.$jlalert.show(res.data);

                this.$jlbutton.unload(e);
            })
            .catch(error => { 
                this.$jlalert.show(error, true);
                this.$jlbutton.unload(e);
            });
        },
        async loadCompanies() {
            await this.$axios.get('/companies')
                  .then(res => {
                    this.companies = res.data;
                  })
                  .catch(error => {
                    this.$jlalert.show(error, true);
                  })
        },
        async sesslogin(crf_no){
          this.data.username = this.$route.query.id;
          // var crf_no = this.$route.query.crf_no;
          // this.data.username = query;
          // this.data.password = "sesslogin";
          // this.signin();
          await this.$axios.post('/sesslogin', this.$qs.stringify(this.data))
            .then(res => {
                console.log(res);
                  if(res.status === 200) location.assign(`http://localhost:8082/crf?crf=${crf_no}`);
            })
            .catch(err => {
                console.log(err);
            })
            
    }
    },
    mounted() {

        if(this.$route.query.id){
          var crf_no = this.$route.query.crf_no;
          this.sesslogin(crf_no);

        } 


        if(this.$route.query.show401) {
            this.$router.replace({query:{show401:undefined}});
            this.$jlalert.show("Unauthorized Access, please relogin");
        }
        

        // this.loadCompanies();
    }
}
</script>

<style scoped>

</style>